/**
 * popularity-sort.js
 * Shared popularity-rank ordering for the /search controller and (Phase 2) the
 * collection takeover. Exposes window.PopularitySort. IIFE, no deps.
 */
(function () {
  'use strict';

  /* Valid rank = positive integer (1+). Missing / empty / 0 / non-positive /
     non-numeric all mean "unranked" and must sort LAST, so they map to Infinity. */
  function parseRank(value) {
    const n = parseInt(value, 10);
    return (Number.isInteger(n) && n >= 1) ? n : Infinity;
  }

  /* Stable ascending sort by rank. rankOf(item) returns an item's raw rank value;
     it is parsed here. Array.prototype.sort is stable (ES2019+), so equal ranks
     and unranked (Infinity) keep their incoming order. Mutates and returns list. */
  function sortByRank(list, rankOf) {
    return list.sort(function (a, b) {
      return parseRank(rankOf(a)) - parseRank(rankOf(b));
    });
  }

  window.PopularitySort = { parseRank: parseRank, sortByRank: sortByRank };
})();
